import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const CreateProfile = () => {
    // const BASE_URL = 'http://localhost:8080'
    const BASE_URL = 'https://beingdiplomatic.hmtbasic2ai.info'
    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        email_address: "",
        sex: "",
        nationality: "",
        title: "",
        town_of_birth: "",
        date_of_birth:"",
        phone_number:""
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const validate = () => {
        if (!form.first_name?.trim()) return "First name is required";
        if (!form.last_name?.trim()) return "Last name is required";
        if (!form.email_address?.trim()) return "Email is required";
        if (!form.sex?.trim()) return "Sex is required";
        if (!form.date_of_birth?.trim()) return "Date of Birth is required";
        if (!form.phone_number?.trim()) return "Phone Number is required";
        return null;
    };

    const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validate();
    if (error) {
        Swal.fire({
            icon: "error",
            title: "Validation Error",
            text: error
        });
        return;
    }

    try {

        const token = localStorage.getItem("token");

        const res = await axios.post(
            `${BASE_URL}/api/users/create_user`,
            form,   // ✅ DATA FIRST
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data?.message || "User created successfully"
        });

        // reset form
        setForm({
            first_name: "",
            last_name: "",
            email_address: "",
            sex: "",
            nationality: "",
            title: "",
            town_of_birth: "",
            date_of_birth:"",
            phone_number:""
        });

    } catch (err) {
        Swal.fire({
            icon: "error",
            title: "Error",
            text: err.response?.data?.message || err.message
        });
    }
};

    return (
        <div className="container mt-4 bg-light shadow-sm p-2">
            <h3 className="mb-2">Create User Profile</h3>

            <form onSubmit={handleSubmit} className="row g-3">

                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        name="first_name"
                        value={form.first_name}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Last Name"
                        name="last_name"
                        value={form.last_name}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-6">
                    <input
                        type="email"
                        className="form-control"
                        placeholder="Email Address"
                        name="email_address"
                        value={form.email_address}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-6">
                    <select
                        className="form-control"
                        name="sex"
                        value={form.sex}
                        onChange={handleChange}
                    >
                        <option value="">Select Sex</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="T">Other</option>
                    </select>
                </div>

                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nationality"
                        name="nationality"
                        value={form.nationality}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Title"
                        name="title"
                        value={form.title}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-12">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Town of Birth"
                        name="town_of_birth"
                        value={form.town_of_birth}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-12">
                    <input
                        type="date"
                        className="form-control"
                        placeholder="Date of Birth"
                        name="date_of_birth"
                        value={form.date_of_birth}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-12">
                    <input
                        type="number"
                        className="form-control"
                        placeholder="Phone Number"
                        name="phone_number"
                        value={form.phone_number}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-12">
                    <button className="btn btn-primary">
                        Create User
                    </button>
                </div>

            </form>
        </div>
    );
};

export default CreateProfile;